import script from "./wevlet.vue?vue&type=script&setup=true&lang=js"
export * from "./wevlet.vue?vue&type=script&setup=true&lang=js"

import "./wevlet.vue?vue&type=style&index=0&id=5d677843&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d677843"]])

export default __exports__